import BreadCrumb from "Components/Common/BreadCrumb";
import React from "react";
import { Container, Row } from "reactstrap";
import ActivityReportWidgets from "./ActivityReportWidgets";
import ActiveUserStats from "./ActiveUserStats";
import TopPages from "./TopPages";
import MostViewedContent from "./MostViewedContent";

const ActivityReport = () => {
  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid>
          <BreadCrumb
            title="Activity Report"
            pageTitles={[
              { title: "Dashboard", link: "/dashboard" },
              { title: "User Activity", link: "#" },
            ]}
          />
          <Row>
            <ActivityReportWidgets />
          </Row>
          <Row>
            <ActiveUserStats />
            <TopPages />
          </Row>
          <Row>
            <MostViewedContent />
          </Row>
        </Container>
      </div>
    </React.Fragment>
  );
};

export default ActivityReport;
